import { useTranslations } from 'hooks/useTranslations';

export const usePageTitle = (title: string) => {
  const translations = useTranslations();
  const productName = translations.product.name();

  return `${title} | ${productName}`;
};
